export default {
    'replenish.spmc': 'Product name',
    'replenish.lx': 'Type',
    'replenish.sl': 'Quantity',
    'replenish.bh': 'Replenishment'
}